import {
  BMComponentsType,
  BMInputField,
  useBMTheme,
} from "@traveloka/district-bloom";
import IcSystemChevronDown from "@traveloka/icon-kit-web/react/IcSystemChevronDown";
import { useState } from "react";
import { Controller, useFormContext } from "react-hook-form";
import { KeyboardAvoidingView, StyleSheet } from "react-native";
import BMView from "../../../../../components/View/BMView";
import { useMobileContentResource } from "../../../../../core/resource/MobileResourceProvider";
import { useTravelerPickerContextV2 } from "../../../../../providers/TravelerPickerContextV2";
import { appendTestId } from "../../../../../utils";
import { BMCheckboxSelectionRHF } from "../../BMCheckboxSelection";
import { SelectEmployeeFormValues } from "./types";

const testID = "division-filter";

export default function SelectEmployeeDrawerDivisionFilter() {
  const [isVisible, setVisible] = useState(false);
  const { CorporateTravelerPicker: cr } = useMobileContentResource();
  const { divisionOptions } = useTravelerPickerContextV2();

  const { BMComponents } = useBMTheme();
  const styles = createStyles(BMComponents);

  const { control } = useFormContext<SelectEmployeeFormValues>();

  return (
    <KeyboardAvoidingView>
      <BMView style={styles.divisionsContainer}>
        <Controller
          control={control}
          name="divisions"
          render={({ field: { value } }) => (
            <BMInputField
              value={
                value.length
                  ? `${
                      value.length
                    } ${cr.divisionInputPlaceholder.toLowerCase()}`
                  : ""
              }
              placeholder={cr.divisionInputPlaceholder}
              variant="DROPDOWN"
              onDropdownToggle={() => setVisible(true)}
              buttonInsetType="BUTTON_ICON"
              buttonInsetProps={{
                Icon: IcSystemChevronDown,
                onPress: () => {},
                iconStyle: styles.dropdownIcon,
              }}
              testID={appendTestId(testID, "input")}
            />
          )}
        />
      </BMView>
      <BMCheckboxSelectionRHF
        isVisible={isVisible}
        setVisible={setVisible}
        name="divisions"
        options={divisionOptions}
        title={cr.divisionTrayTitle}
        inputPlaceholder={cr.divisionInputPlaceholder}
        testID={appendTestId(testID, "selection")}
      />
    </KeyboardAvoidingView>
  );
}

function createStyles(BMComponents: BMComponentsType) {
  return StyleSheet.create({
    divisionsContainer: {
      width: 120,
    },
    dropdownIcon: {
      color: BMComponents.BMStyleIconInkSecondary,
      // @ts-expect-error react-native-web only
      accentColor: BMComponents.BMStyleIconInkSecondary,
      fillColor: BMComponents.BMStyleIconInkSecondary,
    },
  });
}
